import axios from "axios";
import { compress } from "../helpers/common.helper";

const apiUri = import.meta.env.GATEWAY_URI;

export default function useLandingPage() {
  const queryLandingPageConfigs = async (
    filter,
    page,
    limit,
    sort,
    project
  ) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (sort) reqBody.sort = sort;
    if (project) reqBody.project = project;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/promotes/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const getLandingPageConfig = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/promotes/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  const createLandingPageConfig = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/promotes`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const patchLandingPageConfig = async (_id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/promotes/${_id}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const deleteLandingPage = async (_id) => {
    const result = await axios.delete(`${apiUri}/api/v1/promotes/${_id}`, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const queryPriorities = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/promotes/priorities/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const createPriority = async (_id, date, value) => {
    const reqBody = { date, value };

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/promotes/${_id}/priorities`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const patchPriority = async (_id, priorityId, value) => {
    const reqBody = { value };

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.patch(
      `${apiUri}/api/v1/promotes/${_id}/priorities/${priorityId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getRanking = async (price, startDate, endDate) => {
    const result = await axios.get(
      `${apiUri}/api/v1/promotes/rankings?price=${price}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data?.data;
  };

  const getDailyRanking = async (category, section, date) => {
    const result = await axios.get(`${apiUri}/api/v1/promotes/dailyRanking`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        category,
        section,
        date,
      },
    });
    return result.data?.data;
  };

  return {
    queryLandingPageConfigs,
    getLandingPageConfig,
    createLandingPageConfig,
    patchLandingPageConfig,
    deleteLandingPage,
    queryPriorities,
    createPriority,
    patchPriority,
    getRanking,
    getDailyRanking,
  };
}
